export const isValidGooglePayMerchantId = (source: string): boolean => {
  if (typeof source !== 'string') {
    return false;
  }

  return source !== undefined && source !== null && source.trim().length !== 0;
};
